import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '../styled';
export var AccordionSummaryComponentName = 'QuantumAcccordionSummary';
export var AccordionSummary = styled(MuiAccordionSummary, {
    name: AccordionSummaryComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme;
    return {
        borderTop: "1px solid ".concat(theme.tokens.color_border_default),
        borderBottom: "1px solid ".concat(theme.tokens.color_border_default),
        backgroundColor: theme.tokens.color_bg_layer,
        marginBottom: -1,
        minHeight: theme.typography.pxToRem(72),
        '&.Mui-expanded': {
            minHeight: theme.typography.pxToRem(72),
        },
    };
});
